import { Component, EventEmitter, Input, Output } from '@angular/core';
import { faChartNetwork } from '@fortawesome/pro-solid-svg-icons';
import { ModalController, PopoverController } from '@ionic/angular';
import { environment } from '../../../../../environments/environment';
import { Installer, InstallerTeamLead } from '../../../../domains/users';
import { Connection } from '../../../../domains/users/connection/connection.model';
import { QrCodeModalComponent } from '../qr-code-modal/qr-code-modal.component';

@Component({
  selector: 'gc-sidebar-header',
  templateUrl: './sidebar-header.component.html',
  styleUrls: ['./sidebar-header.component.scss'],
})
export class SidebarHeaderComponent {
  @Input() installer!: InstallerTeamLead;
  @Input() connection?: Connection;
  @Input() canEditProfile = false;

  @Output() called = new EventEmitter<Installer>();
  @Output() emailed = new EventEmitter<Installer>();
  @Output() websiteVisited = new EventEmitter<Installer>();
  @Output() optionsOpened = new EventEmitter<{ event: Event; installer: Installer }>();
  @Output() closeProfileModal = new EventEmitter<{ event: Event; installer: Installer }>();
  @Output() editMyProfile = new EventEmitter<{ event: Event; installer: Installer }>();

  protected readonly faChartNetwork = faChartNetwork;

  constructor(
    public readonly popoverGC: PopoverController,
    private readonly modalGC: ModalController,
  ) {}

  async openQRCodeModal() {
    const profileUrl = `${environment.apiRoot.profiles}${this.installer.externalId}`;
    const modal = await this.modalGC.create({
      component: QrCodeModalComponent,
      componentProps: {
        profileUrl,
      },
    });
    await modal.present();
  }
}
